import { z } from 'zod';
import { SalesOrderItemType } from '../../constants/sales-order-item-type.js';
import { optionalUuidString, requireAtLeastOneField } from '../zod-helpers/index.js';
import { SALES_ORDER_LINE_CONSTRAINTS } from './constraints.js';
import { salesOrderLineNoteSchema } from './item-note.js';
import { salesOrderLineQuantitySchema } from './item-quantity.js';
import { salesOrderLineUnitPriceSchema } from './item-unit-price.js';
// No cross-field zero-revenue/mixing-rule check here: a patch may set only `typeId` (leaving
// the line's existing unitPrice untouched) or only `unitPrice` (leaving its existing typeId
// untouched), so validating those rules against each other needs the line's current DB state,
// not just this patch. The resolver checks both against the merged effective line before
// writing — see update-sales-order-item.ts.
export const updateSalesOrderItemInputSchema = requireAtLeastOneField(z.object({
    qty: salesOrderLineQuantitySchema.optional(),
    unitPrice: salesOrderLineUnitPriceSchema.optional(),
    typeId: z
        .enum(SalesOrderItemType, `Invalid ${SALES_ORDER_LINE_CONSTRAINTS.lineType.label.toLowerCase()}.`)
        .optional(),
    uomId: optionalUuidString(`Invalid ${SALES_ORDER_LINE_CONSTRAINTS.uom.label.toLowerCase()} selection.`)
        .optional()
        .nullable(),
    note: salesOrderLineNoteSchema,
}));
//# sourceMappingURL=update-item-input.js.map